import React from 'react';
import { breakpoints, styled } from '@swibeco/shared';
import { useTheme } from '@emotion/react';

type DeliveryAddressIconProps = {
  id?: string;
  width?: number;
  height?: number;
  color?: string;
};

const DeliveryAddressIconWrapper = styled.span<DeliveryAddressIconProps>`
  display: inline-block;
  width: 32.48px;
  height: 22px;
  ${breakpoints.sm_max} {
    width: 30px;
    height: 30px;
  }
`;

const DeliveryAddressIcon = ({
  id = 'delivery-address-mark',
  width,
  height,
  color,
}: DeliveryAddressIconProps) => {
  const theme = useTheme();
  return (
    <DeliveryAddressIconWrapper
      id={id}
      color={color}
      width={width}
      height={height}
    >
      <svg viewBox="0 0 37 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.34766 14.6309H22.8831V20.226H10.027C10.027 20.226 9.49239 18.289 6.88372 18.289C4.27505 18.289 3.29092 20.8649 3.29092 20.8649L1.34766 20.226L1.34766 14.6309Z"
          fill={color || theme.colors.primary.main}
          fillOpacity={0.1}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.2077 11.5878L33.6555 10.4944L31.4883 6.31985C30.9025 5.17681 29.7143 4.46448 28.4173 4.47276H24.6853V3.42912C24.6853 1.54062 23.1623 0 21.2545 0H3.41429C1.50643 0 0.000222613 1.5489 0.000222613 3.42912V19.4151C-0.0165116 20.5664 0.912313 21.5107 2.07544 21.5272C2.08381 21.5272 2.09217 21.5272 2.10891 21.5272H2.55241C2.55241 21.6101 2.54404 21.6432 2.54404 21.6929C2.53567 24.0618 4.46864 25.9917 6.86183 26C9.25502 26.0083 11.2047 24.0949 11.2131 21.726C11.2131 21.7095 11.2131 21.7012 11.2131 21.6846C11.2131 21.6266 11.2131 21.6018 11.2047 21.519H25.6225C25.6225 21.6018 25.6225 21.6349 25.6225 21.6846C25.6141 24.0535 27.5471 25.9834 29.9403 25.9917C32.3335 26 34.2832 24.0867 34.2915 21.7177C34.2915 21.7012 34.2915 21.6929 34.2915 21.6763C34.2915 21.6183 34.2915 21.5935 34.2915 21.5107H35.371C36.5341 21.5107 37.4797 20.5747 37.4797 19.4234C37.4797 19.4151 37.4797 19.4068 37.4797 19.3902V13.5094C37.4964 12.6977 36.9943 11.9274 36.2077 11.5878H36.2077ZM6.88693 24.3517C5.41419 24.3517 4.22596 23.1755 4.22596 21.7177C4.22596 20.2599 5.41419 19.0838 6.88693 19.0838C8.35966 19.0838 9.54789 20.2599 9.54789 21.7177C9.54789 23.1672 8.35129 24.3517 6.88693 24.3517ZM23.0117 19.8872H10.8114C10.1085 18.3714 8.56885 17.4024 6.88693 17.4106C5.19663 17.4024 3.66532 18.3632 2.96243 19.8872H2.10891C1.84951 19.8872 1.67378 19.6884 1.67378 19.4317V15.166H23.0117V19.8872ZM23.0117 3.4374V13.5094H1.67378V3.4374C1.67378 2.4683 2.43525 1.66486 3.41429 1.66486H21.2545C22.2335 1.67314 23.0201 2.4683 23.0117 3.42912V3.4374ZM24.6853 6.13762H28.4173C29.0784 6.12934 29.6976 6.4855 30.0072 7.07359L31.6808 10.2791H24.6853V6.13762ZM29.9654 24.3517C28.4926 24.3517 27.3044 23.1755 27.3044 21.7177C27.3044 20.2599 28.4926 19.0838 29.9654 19.0838C31.4381 19.0838 32.6263 20.2599 32.6263 21.7177C32.6263 23.1672 31.4381 24.3517 29.9654 24.3517ZM35.8144 19.4317C35.8144 19.6884 35.6387 19.8872 35.3793 19.8872H33.8898C32.8773 17.7419 30.3001 16.8143 28.1328 17.8165C27.2123 18.2389 26.4676 18.9761 26.0408 19.8872H24.6853V11.9356H32.8857L35.5467 13.0952C35.714 13.1781 35.8228 13.3603 35.8144 13.5425V19.4317Z"
          fill={color || theme.colors.primary.main}
        />
      </svg>
    </DeliveryAddressIconWrapper>
  );
};

export default DeliveryAddressIcon;
